(function () {
  function syncPanels(nav) {
    var gender = nav.getAttribute('data-active-gender') || 'erkek';
    var tab = nav.getAttribute('data-active-tab') || 'giyim';

    nav.querySelectorAll('[data-hole-mnav-panel]').forEach(function (panel) {
      var match =
        panel.getAttribute('data-gender') === gender &&
        panel.getAttribute('data-tab') === tab;
      panel.classList.toggle('is-active', match);
      if (match) {
        panel.removeAttribute('hidden');
      } else {
        panel.setAttribute('hidden', '');
      }
    });

    nav.querySelectorAll('[data-hole-mnav-featured]').forEach(function (list) {
      var match = list.getAttribute('data-gender') === gender;
      list.classList.toggle('is-active', match);
      if (match) {
        list.removeAttribute('hidden');
      } else {
        list.setAttribute('hidden', '');
      }
    });
  }

  function setActive(group, attr, value) {
    group.forEach(function (btn) {
      var on = btn.getAttribute(attr) === value;
      btn.classList.toggle('is-active', on);
      btn.setAttribute('aria-selected', on ? 'true' : 'false');
    });
  }

  function initialGender() {
    try {
      return /\/pages\/kadin\/?$/i.test(location.pathname) ? 'kadin' : 'erkek';
    } catch (e) {
      return 'erkek';
    }
  }

  function bindNav(nav) {
    if (nav.dataset.holeMnavBound === '1') return;
    nav.dataset.holeMnavBound = '1';

    var gender = initialGender();
    var tab = 'giyim';
    nav.setAttribute('data-active-gender', gender);
    nav.setAttribute('data-active-tab', tab);

    var genderBtns = Array.from(nav.querySelectorAll('[data-hole-mnav-gender]'));
    var tabBtns = Array.from(nav.querySelectorAll('[data-hole-mnav-tab]'));

    setActive(genderBtns, 'data-hole-mnav-gender', gender);
    setActive(tabBtns, 'data-hole-mnav-tab', tab);

    genderBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var next = btn.getAttribute('data-hole-mnav-gender');
        nav.setAttribute('data-active-gender', next);
        setActive(genderBtns, 'data-hole-mnav-gender', next);
        syncPanels(nav);
      });
    });

    tabBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var next = btn.getAttribute('data-hole-mnav-tab');
        nav.setAttribute('data-active-tab', next);
        setActive(tabBtns, 'data-hole-mnav-tab', next);
        syncPanels(nav);
      });
    });

    document.addEventListener('hole:gender-switched', function (event) {
      var url = (event.detail && event.detail.url) || '';
      var next = /\/pages\/kadin/i.test(url) ? 'kadin' : 'erkek';
      nav.setAttribute('data-active-gender', next);
      setActive(genderBtns, 'data-hole-mnav-gender', next);
      syncPanels(nav);
    });

    syncPanels(nav);
  }

  function boot() {
    document.querySelectorAll('[data-hole-mobile-nav]').forEach(bindNav);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);
})();
